export const isSnowplowEnabled: boolean = process.env.NEXT_PUBLIC_SNOWPLOW_ENABLED === 'true'

export const eventSchemas = {
  almostThereLoginCtaClick: 'iglu:com.casavo/almost_there_login_cta_click/jsonschema/1-0-0',
  almostThereMortgageRequestCtaClick: 'iglu:com.casavo/almost_there_mortgage_request_cta_click/jsonschema/1-0-0',
  almostTherePageVisit: 'iglu:com.casavo/almost_there_page_visit/jsonschema/1-0-0',
  buyerSearchResults: 'iglu:com.casavo/buyer_search_results/jsonschema/1-0-0',
}

type EventSchema = typeof eventSchemas

interface AlmostThereLoginCtaClickEvent {
  data: {
    google_client_id?: string
    userId?: string
    valuation_session_id?: string
  }
  schema: EventSchema['almostThereLoginCtaClick']
}

interface AlmostTherePageVisit {
  data: {
    google_client_id?: string
    status: 'logged-in' | 'not-logged-in'
    userId?: string
    valuation_session_id?: string
  }
  schema: EventSchema['almostTherePageVisit']
}

interface AlmostThereMortgageRequestCtaClick {
  data: {
    googleClientId?: Gtag.CustomParams | string
    location: 'modal' | 'pageContent'
    userId?: string
    valuationSessionId?: string
  }
  schema: EventSchema['almostThereMortgageRequestCtaClick']
}

export enum SearchTabLabel {
  MAIN = 'main',
  PREVIEW = 'preview',
}

export enum SearchType {
  FOR_YOU = 'for_you',
  SEARCH = 'search',
}

export enum PropertyLifecycle {
  OFF_MARKET = 'off-market',
  ON_MARKET = 'on-market',
  PREVIEW = 'preview',
}

export type ListingsShown = {
  listing_id: string
  position: number
  property_lifecycle: PropertyLifecycle
}

interface BuyerSearchResults {
  data: {
    googleClientId?: Gtag.CustomParams | string
    listingsShown: Array<ListingsShown>
    pageNumber: number
    searchCriteria: {}
    searchId?: string
    searchTabLabel: SearchTabLabel
    searchType: SearchType
    sessionId?: Gtag.CustomParams | string
    sorting: string
    userId?: string
  }
  schema: EventSchema['buyerSearchResults']
}

export type SnowplowEvent =
  | AlmostThereLoginCtaClickEvent
  | AlmostTherePageVisit
  | BuyerSearchResults
  | AlmostThereMortgageRequestCtaClick
